(function () {
  "use strict";
  var L = (window.Lagom = window.Lagom || {}),
    C = L.config || {};
  function q(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  ((L.q = q), (L.qa = qa));
  var CAPTURE = /[?&]capture=1(?:&|$)/.test(location.search);
  ((L.off = {}),
    CAPTURE && document.documentElement.classList.add("is-capture"));
  var REDUCE = window.matchMedia
      ? window.matchMedia("(prefers-reduced-motion: reduce)")
      : { matches: !1 },
    OFF = C.motion && C.motion.enabled === !1;
  ((L.MOTION = {
    get matches() {
      return CAPTURE || OFF || !!REDUCE.matches;
    },
    addEventListener: function (type, fn) {
      REDUCE.addEventListener
        ? REDUCE.addEventListener(type, fn)
        : REDUCE.addListener && REDUCE.addListener(fn);
    },
  }),
    (L.motionOff = function () {
      return L.MOTION.matches;
    }),
    (L.CAPTURE = CAPTURE),
    (L.lock = (function () {
      var keys = {}, frozen = null,
        PANELS = ".cart-panel, .manifesto, .header__nav, .lsel__menu";
      return (
        document.addEventListener(
          "touchmove",
          function (e) {
            if (Object.keys(keys).length && !(e.touches.length > 1)) {
              var panel = e.target.closest && e.target.closest(PANELS);
              if (panel)
                for (var el = e.target; el && el !== panel.parentNode;) {
                  var cs = getComputedStyle(el);
                  if (
                    /auto|scroll/.test(cs.overflowY) &&
                    el.scrollHeight > el.clientHeight + 1
                  )
                    return;
                  el = el.parentNode;
                }
              e.cancelable && e.preventDefault();
            }
          },
          { passive: !1 },
        ),
        {
          lock: function (k, freezePage) {
            // The cart opens after an asynchronous request. Touch cancellation
            // alone cannot stop iOS focus/viewport scrolling during that open.
            if (freezePage && !frozen) {
              var body = document.body, style = body.style;
              frozen = { key: k, x: window.pageXOffset, y: window.pageYOffset, styles: {} };
              ["position", "top", "left", "width"].forEach(function (name) {
                frozen.styles[name] = [style.getPropertyValue(name), style.getPropertyPriority(name)];
              });
              var gutter = window.innerWidth - document.documentElement.clientWidth;
              style.setProperty("position", "fixed");
              style.setProperty("top", -frozen.y + "px");
              style.setProperty("left", -frozen.x + "px");
              style.setProperty("width", "calc(100% - " + gutter + "px)");
            }
            ((keys[k] = !0),
              document.documentElement.classList.add("is-locked"));
          },
          unlock: function (k) {
            (delete keys[k],
              Object.keys(keys).length ||
                document.documentElement.classList.remove("is-locked"));
            if (frozen && frozen.key === k) {
              var saved = frozen;
              frozen = null;
              Object.keys(saved.styles).forEach(function (name) {
                var value = saved.styles[name];
                if (value[0]) document.body.style.setProperty(name, value[0], value[1]);
                else document.body.style.removeProperty(name);
              });
              window.scrollTo({ left: saved.x, top: saved.y, behavior: "instant" });
            }
          },
          has: function (k) {
            return !!keys[k];
          },
          y: function () {
            return frozen ? frozen.y : window.pageYOffset;
          },
        }
      );
    })()),
    (L.inApp = (function (ua) {
      return /musical_ly|Bytedance|TikTok|Trill|Aweme/i.test(ua)
        ? "TikTok"
        : /Instagram/i.test(ua)
          ? "Instagram"
          : /FBAN|FBAV|FB_IAB|FBIOS|Messenger/i.test(ua)
            ? "Facebook"
            : /Snapchat/i.test(ua)
              ? "Snapchat"
              : /Line\//.test(ua)
                ? "Line"
                : /Twitter|X11; .*Mobile.*Twitter/i.test(ua)
                  ? "X"
                  : /; wv\)|Version\/[\d.]+ Chrome\/[\d.]+ Mobile/.test(ua) &&
                      /Android/.test(ua)
                    ? "Android WebView"
                    : /iPhone|iPad|iPod/.test(ua) &&
                        !/Safari\//.test(ua) &&
                        !/CriOS|FxiOS|EdgiOS/.test(ua)
                      ? "iOS WebView"
                      : "";
    })(navigator.userAgent || "")),
    (L.lite = !!L.inApp),
    (L.scrollY = 0),
    window.addEventListener(
      "scroll",
      function () {
        L.scrollY = L.lock.y();
      },
      { passive: !0 },
    ),
    window.requestAnimationFrame(function () {
      L.scrollY = L.lock.y();
    }),
    (L.idle = function (fn) {
      var run = function () {
        try {
          fn();
        } catch (e) {
          window.console && console.error(e);
        }
      };
      window.requestIdleCallback
        ? window.requestIdleCallback(run, { timeout: 1500 })
        : window.setTimeout(run, 1);
    }),
    L.lite && document.documentElement.classList.add("is-lite"),
    (L.zoomed = function () {
      return !!(window.visualViewport && window.visualViewport.scale > 1.05);
    }),
    window.visualViewport &&
      (function (vv) {
        var on = !1;
        function check() {
          var z = vv.scale > 1.05;
          z !== on &&
            ((on = z),
            document.documentElement.classList.toggle("is-zoomed", z));
        }
        (vv.addEventListener("resize", check),
          check(),
          L.lite &&
            (document.addEventListener(
              "touchstart",
              function (e) {
                e.touches.length > 1 &&
                  !on &&
                  ((on = !0),
                  document.documentElement.classList.add("is-zoomed"));
              },
              { passive: !0 },
            ),
            document.addEventListener(
              "touchend",
              function (e) {
                e.touches.length ||
                  window.setTimeout(function () {
                    ((on = vv.scale > 1.05),
                      document.documentElement.classList.toggle(
                        "is-zoomed",
                        on,
                      ));
                  }, 400);
              },
              { passive: !0 },
            )));
      })(window.visualViewport),
    (L.track = function (name, detail) {
      if (!(!name || typeof window.clarity != "function"))
        try {
          (detail && window.clarity("set", name, detail),
            window.clarity("event", name));
        } catch (e) {}
    }),
    document.addEventListener("click", function (e) {
      var el = e.target.closest && e.target.closest("[data-track]");
      el &&
        L.track(
          el.getAttribute("data-track"),
          el.getAttribute("data-track-detail"),
        );
    }),
    (L.onView = function (el, fn, opts) {
      if (el) {
        if (!("IntersectionObserver" in window)) {
          fn({ isIntersecting: !0, target: el });
          return;
        }
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              en.isIntersecting && (io.unobserve(en.target), fn(en));
            });
          },
          opts || { rootMargin: "0px 0px -10% 0px" },
        );
        io.observe(el);
      }
    }),
    (L.seHolidays = function (y) {
      for (
        var a = y % 19,
          b = Math.floor(y / 100),
          c = y % 100,
          d = Math.floor(b / 4),
          e = b % 4,
          f = Math.floor((b + 8) / 25),
          g = Math.floor((b - f + 1) / 3),
          h = (19 * a + b - d - g + 15) % 30,
          i = Math.floor(c / 4),
          k = c % 4,
          l = (32 + 2 * e + 2 * i - h - k) % 7,
          m = Math.floor((a + 11 * h + 22 * l) / 451),
          easter = Date.UTC(
            y,
            Math.floor((h + l - 7 * m + 114) / 31) - 1,
            ((h + l - 7 * m + 114) % 31) + 1,
          ),
          iso = function (t) {
            return new Date(t).toISOString().slice(0, 10);
          },
          midsummer = Date.UTC(y, 5, 19);
        new Date(midsummer).getUTCDay() !== 5;
      )
        midsummer += 864e5;
      return [
        "01-01",
        "01-06",
        "05-01",
        "06-06",
        "12-24",
        "12-25",
        "12-26",
        "12-31",
      ]
        .map(function (md) {
          return y + "-" + md;
        })
        .concat([
          iso(easter - 2 * 864e5),
          iso(easter + 864e5),
          iso(easter + 39 * 864e5),
          iso(midsummer),
        ]);
    }),
    (L.visitorCountry = function () {
      var W = window.LagomWL;
      return (W && W.country) || C.country || "";
    }),
    (L.arrivalText = function (info, short) {
      var t = C.t || {};
      return info.single
        ? L.fill(t.arrivesOn || "Arrives [date]", {
            date: short ? info.arriveShort : info.arriveDate,
          })
        : L.fill(t.arrivesBetween || "Arrives [range]", {
            range: short ? info.arriveShort : info.arriveRange,
          });
    }),
    (L.dispatchInfo = function (now) {
      var c = C.cutoff || {
          hour: 15,
          minute: 0,
          tz: "Europe/Stockholm",
          days: ["1", "2", "3", "4", "5"],
          holidays: [],
        },
        d = C.delivery || {
          home: "SE",
          handling: 1,
          homeDays: 2,
          min: 2,
          max: 4,
        },
        locale = C.locale || "en",
        s = C.ship || {},
        days = (c.days || [])
          .map(function (x) {
            return ((x = parseInt(x, 10)), x === 7 ? 0 : x);
          })
          .filter(function (x) {
            return !isNaN(x);
          }),
        parts = new Intl.DateTimeFormat("en-CA", {
          timeZone: c.tz,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hourCycle: "h23",
        }).formatToParts(now || new Date()),
        get = function (t) {
          for (var i = 0; i < parts.length; i++)
            if (parts[i].type === t) return parseInt(parts[i].value, 10);
          return 0;
        },
        day = new Date(Date.UTC(get("year"), get("month") - 1, get("day"))),
        holidays = (c.holidays || [])
          .map(function (x) {
            return String(x).trim();
          })
          .filter(Boolean)
          .concat(L.seHolidays(get("year")), L.seHolidays(get("year") + 1)),
        iso = function (x) {
          return x.toISOString().slice(0, 10);
        },
        isDispatch = function (x) {
          return (
            days.indexOf(x.getUTCDay()) !== -1 &&
            holidays.indexOf(iso(x)) === -1
          );
        },
        isBusiness = function (x) {
          var w = x.getUTCDay();
          return w !== 0 && w !== 6 && holidays.indexOf(iso(x)) === -1;
        },
        next = function (x, test) {
          for (var r = new Date(x.getTime() + 864e5); !test(r);)
            r = new Date(r.getTime() + 864e5);
          return r;
        },
        after = function (x, n) {
          for (var k = 0; k < n; k++) x = next(x, isBusiness);
          return x;
        },
        minsLeft = c.hour * 60 + c.minute - (get("hour") * 60 + get("minute")),
        orderToday = isDispatch(day) && minsLeft > 0,
        ship = orderToday ? day : next(day, isDispatch),
        batchAt = s.mode === "batch" && s.at ? Date.parse(s.at) : NaN,
        batchPending = batchAt > (now || new Date()).getTime();
      if (batchPending) {
        var bp = new Intl.DateTimeFormat("en-CA", {
            timeZone: c.tz,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }).format(new Date(batchAt)),
          bday = new Date(bp + "T00:00:00Z");
        ((ship = isDispatch(bday) ? bday : next(bday, isDispatch)),
          (orderToday = !1));
      }
      if (!batchPending)
        for (var hd = 0; hd < (d.handling || 0); hd++)
          ship = next(ship, isDispatch);
      var country = L.visitorCountry(),
        home = !country || country === (d.home || "SE"),
        from = after(ship, home ? d.homeDays : d.min),
        to = after(ship, home ? d.homeDays : d.max),
        fmt = function (x, o) {
          return new Intl.DateTimeFormat(
            locale,
            Object.assign({ timeZone: "UTC" }, o),
          ).format(x);
        },
        range = function (a, b, month) {
          var o = { day: "numeric", month: month, timeZone: "UTC" };
          try {
            return new Intl.DateTimeFormat(locale, o).formatRange(a, b);
          } catch (e) {
            return fmt(a, o) + " \u2013 " + fmt(b, o);
          }
        },
        single = iso(from) === iso(to);
      return {
        orderToday: orderToday,
        minsLeft: orderToday ? minsLeft : 0,
        batchPending: batchPending,
        shipsToday: iso(ship) === iso(day),
        shipTomorrow: ship - day === 864e5,
        shipName: fmt(ship, { weekday: "long" }),
        single: single,
        arriveDate: fmt(from, {
          weekday: "long",
          day: "numeric",
          month: "long",
        }),
        arriveRange: range(from, to, "long"),
        arriveShort: single
          ? fmt(from, { weekday: "short", day: "numeric", month: "short" })
          : range(from, to, "short"),
        arriveGet: fmt(from, {
          weekday: "long",
          day: "numeric",
          month: "short",
        }),
        deliverLabel: fmt(to, {
          weekday: "short",
          day: "numeric",
          month: "short",
        }),
        deliverLong: fmt(to, {
          weekday: "long",
          day: "numeric",
          month: "short",
        }),
      };
    }),
    (L.localizeBatch = function (root) {
      var s = C.ship || {},
        at = Date.parse(s.at || ""),
        locale = C.locale || "en";
      if (!(!(at > Date.now()) || locale.slice(0, 2) === "en")) {
        var tz = (C.cutoff || {}).tz || "Europe/Stockholm",
          swap = [
            [s.window, { day: "numeric", month: "long" }],
            [s.short, { day: "numeric", month: "short" }],
          ]
            .filter(function (x) {
              return x[0];
            })
            .map(function (x) {
              return [
                x[0],
                new Intl.DateTimeFormat(
                  locale,
                  Object.assign({ timeZone: tz }, x[1]),
                ).format(new Date(at)),
              ];
            });
        qa(
          "[data-eta-sub], .announcement__text, .buybar__delivery, .cart-panel__note, .cart__note",
          root,
        ).forEach(function (el) {
          for (
            var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
            (n = w.nextNode());
          ) {
            var v = n.nodeValue;
            (swap.forEach(function (x) {
              v.indexOf(x[0]) > -1 && (v = v.split(x[0]).join(x[1]));
            }),
              v !== n.nodeValue && (n.nodeValue = v));
          }
        });
      }
    }),
    (L.fillArrivals = function (root) {
      if (!C.delivery || !C.delivery.enabled) return;
      try {
        L.localizeBatch(root);
      } catch (e) {}
      var els = qa("[data-arrives-short]", root);
      if (els.length)
        try {
          var info = L.dispatchInfo(new Date()),
            t = C.t || {},
            text = L.arrivalText(info, !0),
            get = L.fill(t.getIt || "Get it [date]", {
              date: info.single ? info.arriveGet : info.arriveShort,
            });
          els.forEach(function (el) {
            ((el.textContent =
              (el.hasAttribute("data-arrives-sep") ? " \xB7 " : "") +
              (el.hasAttribute("data-arrives-get") ? get : text)),
              (el.hidden = !1));
          });
        } catch (e) {}
    }),
    (L.batchCountdown = function () {
      var s = C.ship || {};
      if (s.mode !== "batch" || !s.at) return null;
      var ms = Date.parse(s.at) - Date.now();
      if (!(ms > 0)) return null;
      var t = Math.floor(ms / 1e3);
      return {
        days: Math.ceil(ms / 864e5),
        text:
          Math.floor(t / 86400) +
          "d " +
          Math.floor((t % 86400) / 3600) +
          "h " +
          Math.floor((t % 3600) / 60) +
          "m " +
          (t % 60) +
          "s",
      };
    }),
    (L.fill = function (tpl, vars) {
      return String(tpl || "").replace(/\[(\w+)\]/g, function (m, k) {
        return vars[k] != null ? vars[k] : m;
      });
    }),
    (function () {
      var run = function () {
        L.fillArrivals();
      };
      (document.readyState === "loading"
        ? document.addEventListener("DOMContentLoaded", run)
        : run(),
        [1500, 4e3].forEach(function (ms) {
          setTimeout(run, ms);
        }),
        setInterval(run, 6e4),
        document.addEventListener("lagom:cart", function () {
          setTimeout(run, 50);
        }),
        document.addEventListener("shopify:section:load", run));
    })(),
    (function () {
      var header = q("[data-header]");
      if (!header) return;
      var lights = qa("[data-light]"),
        raf = 0,
        floating = !1,
        ann = q("[data-announcement]"),
        annH = 0,
        headMid = 40,
        ranges = [],
        lastTop = "";
      function measure() {
        var y = L.lock.y();
        annH = ann ? ann.offsetHeight : 0;
        var inner = q(".header__inner", header),
          r = inner
            ? inner.getBoundingClientRect()
            : header.getBoundingClientRect();
        ((headMid = r.top + r.height / 2),
          (ranges = lights.map(function (el) {
            var b = el.getBoundingClientRect();
            return [b.top + y, b.bottom + y];
          })),
          document.documentElement.style.setProperty("--ann-h", annH + "px"));
      }
      function update() {
        raf = 0;
        var y = L.scrollY,
          on = y > 24,
          top = Math.max(0, annH - y) + "px";
        (top !== lastTop && ((header.style.top = top), (lastTop = top)),
          on !== floating &&
            ((floating = on),
            header.classList.toggle("is-floating", on),
            on
              ? window.setTimeout(function () {
                  header.classList.add("is-dropped");
                }, 600)
              : header.classList.remove("is-dropped"),
            window.setTimeout(function () {
              L.idle(function () {
                (measure(),
                  document.dispatchEvent(new CustomEvent("lagom:layout")));
              });
            }, 650)));
        for (var mid = y + headMid, light = !1, i = 0; i < ranges.length; i++)
          if (ranges[i][0] <= mid && ranges[i][1] >= mid) {
            light = !0;
            break;
          }
        header.classList.toggle("is-on-light", light);
      }
      function tick() {
        raf || (raf = window.requestAnimationFrame(update));
      }
      (window.addEventListener("scroll", tick, { passive: !0 }),
        window.addEventListener("resize", function () {
          (measure(), tick());
        }),
        window.addEventListener("load", function () {
          (measure(), tick());
        }),
        document.fonts &&
          document.fonts.ready &&
          document.fonts.ready.then(function () {
            (measure(), tick());
          }),
        document.addEventListener("shopify:section:load", function () {
          ((lights = qa("[data-light]")), measure(), tick());
        }),
        document.addEventListener("lagom:layout", function () {
          (measure(), tick());
        }),
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            (measure(), update());
          });
        }));
    })(),
    (function () {
      var btn = q("[data-menu-toggle]"),
        nav = q("[data-menu]"),
        hd = q("[data-header]");
      if (!btn || !nav) return;
      var closeTimer = 0,
        openY = 0;
      function set(open) {
        window.clearTimeout(closeTimer);
        var phone = window.matchMedia("(max-width: 1023px)").matches;
        (open
          ? (document.dispatchEvent(
              new CustomEvent("lagom:panel", { detail: "menu" }),
            ),
            nav.classList.remove("is-closing"),
            nav.classList.add("is-open"),
            hd && hd.classList.add("is-menu-open"),
            (openY = window.pageYOffset),
            phone && L.lock.lock("menu"))
          : nav.classList.contains("is-open") && !L.motionOff()
            ? (nav.classList.add("is-closing"),
              L.lock.unlock("menu"),
              (closeTimer = window.setTimeout(function () {
                (nav.classList.remove("is-open", "is-closing"),
                  hd && hd.classList.remove("is-menu-open"));
              }, 220)))
            : (nav.classList.remove("is-open", "is-closing"),
              hd && hd.classList.remove("is-menu-open"),
              L.lock.unlock("menu")),
          btn.setAttribute("aria-expanded", open ? "true" : "false"));
      }
      (btn.addEventListener("click", function () {
        set(btn.getAttribute("aria-expanded") !== "true");
      }),
        nav.addEventListener("click", function (e) {
          var a = e.target.closest("a");
          if (a) {
            var href = a.getAttribute("href") || "",
              hash =
                href.indexOf("#") >= 0 ? href.slice(href.indexOf("#") + 1) : "",
              path = href.split("#")[0],
              samePage =
                !path ||
                path === location.pathname ||
                path === location.pathname + location.search,
              target = hash && samePage ? document.getElementById(hash) : null;
            (set(!1),
              target &&
                (e.preventDefault(),
                window.requestAnimationFrame(function () {
                  (target.scrollIntoView({
                    behavior: L.motionOff() ? "auto" : "smooth",
                    block: "start",
                  }),
                    history.replaceState &&
                      history.replaceState(null, "", "#" + hash));
                })));
          }
        }),
        window.addEventListener(
          "scroll",
          function () {
            btn.getAttribute("aria-expanded") === "true" &&
              !L.lock.has("menu") &&
              Math.abs(window.pageYOffset - openY) > 12 &&
              set(!1);
          },
          { passive: !0 },
        ),
        document.addEventListener("click", function (e) {
          btn.getAttribute("aria-expanded") === "true" &&
            !nav.contains(e.target) &&
            !btn.contains(e.target) &&
            set(!1);
        }),
        document.addEventListener("keydown", function (e) {
          e.key === "Escape" &&
            btn.getAttribute("aria-expanded") === "true" &&
            (set(!1), btn.focus());
        }),
        document.addEventListener("lagom:panel", function (e) {
          e.detail !== "menu" &&
            btn.getAttribute("aria-expanded") === "true" &&
            set(!1);
        }));
    })(),
    (function () {
      var counts = qa("[data-cart-count]"),
        toast = q("[data-toast]"),
        toastTimer = 0;
      function setCount(n) {
        counts.forEach(function (el) {
          el.textContent = n;
          var label = el.closest("[data-cart-link]");
          (label &&
            (label.setAttribute(
              "aria-label",
              L.fill(C.t && C.t.cartCount ? C.t.cartCount : "Cart, [n] items", {
                n: n,
              }),
            ),
            label.classList.toggle("has-items", n > 0)),
            document.documentElement.classList.toggle("cart-empty", !(n > 0)),
            el.classList.remove("is-bump"),
            el.offsetWidth,
            el.classList.add("is-bump"));
        });
      }
      function showToast(text) {
        if (toast) {
          var t = q("[data-toast-text]", toast);
          (t && (t.textContent = text),
            (toast.hidden = !1),
            toast.classList.add("is-in"),
            window.clearTimeout(toastTimer),
            (toastTimer = window.setTimeout(function () {
              (toast.classList.remove("is-in"),
                window.setTimeout(function () {
                  toast.hidden = !0;
                }, 300));
            }, 4e3)));
        }
      }
      L.cart = {
        setCount: setCount,
        toast: showToast,
        add: function (id, quantity, opts) {
          var routes = C.routes || {},
            silent = !!(opts && opts.silent);
          return fetch((routes.cartAdd || "/cart/add") + ".js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              items: [{ id: id, quantity: quantity || 1 }],
              sections: "cart-drawer",
            }),
          }).then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok) {
                var err = new Error(
                  data.description || data.message || window.OfflineI18n.cartError,
                );
                throw ((err.data = data), err);
              }
              return fetch((routes.cart || "/cart") + ".js", {
                headers: { Accept: "application/json" },
              })
                .then(function (c) {
                  return c.json();
                })
                .then(function (cart) {
                  return (
                    setCount(cart.item_count),
                    (cart.sections = data.sections),
                    (cart.silent = silent),
                    !silent &&
                      !q("[data-cart-panel]") &&
                      showToast(window.OfflineI18n.added),
                    document.dispatchEvent(
                      new CustomEvent("lagom:cart", { detail: cart }),
                    ),
                    cart
                  );
                });
            });
          });
        },
      };
    })(),
    (function () {
      var els = qa("[data-reveal]");
      if (els.length) {
        if (L.motionOff() || !("IntersectionObserver" in window)) {
          els.forEach(function (el) {
            el.classList.add("is-in");
          });
          return;
        }
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              en.isIntersecting &&
                (en.target.classList.add("is-in"), io.unobserve(en.target));
            });
          },
          { rootMargin: "0px 0px -8% 0px", threshold: 0.1 },
        );
        els.forEach(function (el) {
          io.observe(el);
        });
      }
    })(),
    /[?&]perf=1(?:&|$)/.test(location.search) &&
      (/[?&]key=lagom-test(?:&|$)/.test(location.search) ||
        (window.Shopify && window.Shopify.designMode)) &&
      (function () {
        var ua = navigator.userAgent,
          name =
            L.inApp ||
            (/CriOS|Chrome/.test(ua)
              ? "Chrome"
              : /FxiOS|Firefox/.test(ua)
                ? "Firefox"
                : /Safari/.test(ua)
                  ? "Safari"
                  : "other"),
          hud = document.createElement("div");
        ((hud.className = "perf-hud"),
          hud.setAttribute("aria-hidden", "true"),
          document.body.appendChild(hud));
        var deltas = [],
          last = performance.now(),
          log = [],
          tab = null,
          n = 0;
        function tick(now) {
          var d = now - last;
          for (
            last = now, deltas.push([now, d]);
            deltas.length && deltas[0][0] < now - 2e3;
          )
            deltas.shift();
          if (
            (tab &&
              (tab.frames++,
              d > tab.worst && (tab.worst = d),
              (tab.dropped += Math.max(0, Math.round(d / 16.7) - 1)),
              now > tab.until &&
                (log.unshift(
                  tab.what +
                    " #" +
                    tab.n +
                    ": " +
                    tab.frames +
                    " frames, worst " +
                    Math.round(tab.worst) +
                    " ms, " +
                    tab.dropped +
                    " dropped",
                ),
                (log = log.slice(0, 4)),
                (tab = null))),
            !(n++ % 6))
          ) {
            var worst = 0,
              sum = 0;
            deltas.forEach(function (x) {
              ((sum += x[1]), x[1] > worst && (worst = x[1]));
            });
            var fps = deltas.length
              ? Math.round(1e3 / (sum / deltas.length))
              : 0;
            hud.textContent =
              name +
              "\n" +
              fps +
              " fps  worst 2s: " +
              Math.round(worst) +
              " ms" +
              (log.length ? "\n" + log.join("\n") : "") +
              "\nUA: " +
              ua;
          }
          window.requestAnimationFrame(tick);
        }
        (window.requestAnimationFrame(tick),
          document.addEventListener(
            "click",
            function (e) {
              var sm = e.target.closest && e.target.closest("summary");
              if (sm) {
                var d = sm.parentNode,
                  items = qa("details.faq__item, details[data-animate]");
                tab = {
                  what: d.classList.contains("is-open") ? "close" : "open",
                  n: items.indexOf(d) + 1,
                  frames: 0,
                  worst: 0,
                  dropped: 0,
                  until: performance.now() + 600,
                };
              }
            },
            !0,
          ));
      })(),
    (function () {
      var DUR = 260;
      function bind(d) {
        if (d.dataset.bound) return;
        d.dataset.bound = "1";
        var sum = d.querySelector("summary");
        if (!sum || !sum.nextElementSibling) return;
        var wasOpen = d.open;
        d.open = !0;
        function set(open) {
          (d.classList.toggle("is-open", open),
            sum.setAttribute("aria-expanded", open ? "true" : "false"),
            window.clearTimeout(L.layoutTimer),
            (L.layoutTimer = window.setTimeout(function () {
              L.idle(function () {
                document.dispatchEvent(new CustomEvent("lagom:layout"));
              });
            }, DUR + 40)),
            d.dispatchEvent(
              new CustomEvent("lagom:tab", { detail: { open: open } }),
            ));
        }
        (d.classList.toggle("is-open", wasOpen),
          sum.setAttribute("aria-expanded", wasOpen ? "true" : "false"),
          (d.lagomIsOpen = function () {
            return d.classList.contains("is-open");
          }),
          (d.lagomOpen = function () {
            d.lagomIsOpen() || set(!0);
          }),
          (d.lagomClose = function () {
            d.lagomIsOpen() && set(!1);
          }),
          sum.addEventListener("pointerdown", function () {
            sum.classList.add("is-pressed");
          }),
          ["pointerup", "pointercancel", "pointerleave"].forEach(function (t) {
            sum.addEventListener(t, function () {
              sum.classList.remove("is-pressed");
            });
          }),
          sum.addEventListener("click", function (e) {
            (e.preventDefault(), set(!d.lagomIsOpen()));
          }));
      }
      (qa("details.faq__item, details[data-animate]").forEach(bind),
        document.addEventListener("shopify:section:load", function (e) {
          qa("details.faq__item, details[data-animate]", e.target).forEach(
            bind,
          );
        }),
        document.addEventListener("shopify:block:select", function (e) {
          var d = e.target.closest && e.target.closest("details");
          d && d.lagomOpen && d.lagomOpen();
        }));
      function openHash() {
        var id = location.hash.slice(1);
        if (id) {
          var d = document.getElementById(id);
          d && d.lagomOpen && d.lagomOpen();
        }
      }
      (window.addEventListener("hashchange", openHash), openHash());
    })(),
    L.idle(function () {
      document.addEventListener(
        "touchstart",
        function (e) {
          var t = e.touches && e.touches[0];
          if (t) {
            var x = t.clientX,
              edge = 32;
            if (!(x > edge && x < window.innerWidth - edge)) {
              var y = t.clientY,
                hit =
                  e.target.closest &&
                  e.target.closest(
                    ".buy__slides, .scards, .social__videos, .buy__gallery, [data-edge-guard]",
                  );
              (hit ||
                (hit = qa(
                  ".buy__slides, .scards, .social__videos, .buy__gallery, [data-edge-guard]",
                ).some(function (el) {
                  var r = el.getBoundingClientRect();
                  return r.width > 0 && y >= r.top && y <= r.bottom;
                })),
                hit && e.preventDefault());
            }
          }
        },
        { passive: !1 },
      );
    }),
    L.idle(function () {
      qa("[data-footer-links]").forEach(function (btn) {
        var pop = document.getElementById(btn.getAttribute("aria-controls"));
        if (!pop) return;
        function set(open) {
          ((pop.hidden = !open),
            btn.setAttribute("aria-expanded", open ? "true" : "false"));
        }
        (btn.addEventListener("click", function (e) {
          (e.preventDefault(), e.stopPropagation(), set(pop.hidden));
        }),
          document.addEventListener("click", function (e) {
            !pop.hidden &&
              !pop.contains(e.target) &&
              e.target !== btn &&
              set(!1);
          }),
          document.addEventListener("keydown", function (e) {
            e.key === "Escape" && !pop.hidden && (set(!1), btn.focus());
          }));
      });
    }),
    L.idle(function () {
      (function () {
        var SEL = ".social__videos, [data-swipe-track]",
          el = null,
          x0 = 0,
          y0 = 0,
          s0 = 0,
          lastX = 0,
          lastT = 0,
          vx = 0,
          lock = 0;
        function kids(t) {
          return Array.prototype.filter.call(t.children, function (c) {
            return c.offsetWidth > 0;
          });
        }
        function snap(t, dir) {
          var pad =
              parseFloat(
                getComputedStyle(t).scrollPaddingInlineStart ||
                  getComputedStyle(t).scrollPaddingLeft,
              ) || 0,
            cs = kids(t),
            best = null,
            bd = 1 / 0,
            cur = t.scrollLeft;
          if (
            (cs.forEach(function (c) {
              var d = Math.abs(c.offsetLeft - pad - cur);
              d < bd && ((bd = d), (best = c));
            }),
            !!best)
          ) {
            var i = cs.indexOf(best);
            (dir > 0 &&
              i < cs.length - 1 &&
              best.offsetLeft - pad <= cur + 2 &&
              (best = cs[i + 1]),
              dir < 0 &&
                i > 0 &&
                best.offsetLeft - pad >= cur - 2 &&
                (best = cs[i - 1]),
              t.scrollTo({
                left: Math.max(0, best.offsetLeft - pad),
                behavior: "smooth",
              }));
          }
        }
        (document.addEventListener(
          "touchstart",
          function (e) {
            var t = e.target.closest && e.target.closest(SEL);
            ((el = null),
              !(!t || e.touches.length !== 1) &&
                (L.zoomed() ||
                  ((el = t),
                  (x0 = lastX = e.touches[0].clientX),
                  (y0 = e.touches[0].clientY),
                  (s0 = t.scrollLeft),
                  (lastT = e.timeStamp),
                  (vx = 0),
                  (lock = 0))));
          },
          { passive: !0 },
        ),
          document.addEventListener(
            "touchmove",
            function (e) {
              if (el) {
                if (e.touches.length > 1) {
                  end();
                  return;
                }
                var x = e.touches[0].clientX,
                  y = e.touches[0].clientY,
                  dx = x - x0,
                  dy = y - y0;
                if (!lock) {
                  if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
                  ((lock = Math.abs(dx) > Math.abs(dy) ? 1 : -1),
                    lock === 1 && el.classList.add("is-swiping"));
                }
                if (lock === 1) {
                  (e.preventDefault(), (el.scrollLeft = s0 - dx));
                  var dt = e.timeStamp - lastT;
                  (dt > 0 && (vx = (x - lastX) / dt),
                    (lastX = x),
                    (lastT = e.timeStamp));
                }
              }
            },
            { passive: !1 },
          ));
        function end() {
          if (el) {
            var t = el;
            if (((el = null), lock === 1)) {
              var dir = vx < -0.25 ? 1 : vx > 0.25 ? -1 : 0;
              (snap(t, dir),
                window.setTimeout(function () {
                  t.classList.remove("is-swiping");
                }, 650));
            }
            lock = 0;
          }
        }
        (document.addEventListener("touchend", end, { passive: !0 }),
          document.addEventListener("touchcancel", end, { passive: !0 }));
      })();
    }),
    L.idle(function () {
      (function () {
        if ("IntersectionObserver" in window) {
          var tops = qa(
              'main > *, [id^="shopify-section-footer"], .footer-group > *',
            )
              .filter(function (el, i, arr) {
                return !arr.some(function (o) {
                  return o !== el && o.contains(el);
                });
              })
              .filter(function (el) {
                return (
                  !el.querySelector(
                    ".header, .cart-panel, .cc, dialog, [data-cart-panel], [data-buybar]",
                  ) && !el.matches(".header, .cart-panel")
                );
              }),
            io = new IntersectionObserver(
              function (entries) {
                entries.forEach(function (en) {
                  en.target.classList.toggle(
                    "is-offscreen",
                    !en.isIntersecting,
                  );
                });
              },
              { rootMargin: "120px 0px" },
            );
          tops.forEach(function (el) {
            io.observe(el);
          });
        }
      })();
    }),
    L.idle(function () {
      (function () {
        var idle = window.requestIdleCallback
          ? function (f) {
              window.requestIdleCallback(f, { timeout: 1500 });
            }
          : function (f) {
              window.setTimeout(f, 1);
            };
        function prime(list) {
          list.dataset.primed ||
            ((list.dataset.primed = "1"),
            qa("details img", list).forEach(function (img) {
              (img.loading === "lazy" && (img.loading = "eager"),
                idle(function () {
                  img.decode && img.decode().catch(function () {});
                }));
            }),
            qa("details video", list).forEach(function (v) {
              if (!v.hasAttribute("data-kbd-video")) {
                v.preload === "none" && (v.preload = "metadata");
                var poster = v.getAttribute("poster");
                poster &&
                  idle(function () {
                    var im = new Image();
                    ((im.src = poster),
                      im.decode && im.decode().catch(function () {}));
                  });
              }
            }));
        }
        var lists = qa(".faq__list, .buy__list, .buy__details");
        if (!("IntersectionObserver" in window)) {
          lists.forEach(prime);
          return;
        }
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              en.isIntersecting && (io.unobserve(en.target), prime(en.target));
            });
          },
          { rootMargin: "600px 0px" },
        );
        lists.forEach(function (l) {
          io.observe(l);
        });
      })();
    }));
})();

